export const iconsAdapter = module => {
  // 暂时保留【针对以后可能出现的百川需求】
  return module
}
